import * as React from "react";
import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeOpened = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9 13.2c-3.237 0-5.965-1.654-7.685-4.2C3.035 6.454 5.763 4.8 9 4.8s5.965 1.654 7.685 4.2c-1.72 2.546-4.448 4.2-7.685 4.2m0-9.6C5.17 3.6 1.988 5.648.091 8.682a.6.6 0 0 0 0 .636C1.988 12.352 5.17 14.4 9 14.4s7.012-2.048 8.909-5.082a.6.6 0 0 0 0-.636C16.012 5.648 12.83 3.6 9 3.6m0 7.8a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8",
		clipRule: "evenodd"
	})
});
const Memo = memo(SvgEyeOpened);
export default Memo;
